"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("moment/locale/pt-br");

require("react-dates/initialize");

var _reactDates = require("react-dates");

require("react-dates/lib/css/_datepicker.css");

require("../assets/css/font.css");

require("./DateRange.css");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DateRange = function DateRange(_ref) {
  var className = _ref.className,
      onChange = _ref.onChange,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "onChange", "size"]);

  var _useState = (0, _react.useState)(props.startDate),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = (0, _react.useState)(props.endDate),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var _useState5 = (0, _react.useState)(props.focusedInput),
      _useState6 = _slicedToArray(_useState5, 2),
      focusedInput = _useState6[0],
      setFocusedInput = _useState6[1];

  var wrapperClass = 'daterange';
  if (className) wrapperClass += " ".concat(className);
  if (size === 'small') wrapperClass += ' daterange--small';
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement(_reactDates.DateRangePicker, _extends({}, props, {
    noBorder: true,
    startDate: startDate,
    startDateId: "startDate",
    endDate: endDate,
    endDateId: "endDate",
    onDatesChange: function onDatesChange(_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      setStartDate(startDate);
      setEndDate(endDate);
      onChange({
        startDate: startDate,
        endDate: endDate
      });
    },
    focusedInput: focusedInput,
    onFocusChange: function onFocusChange(focusedInput) {
      return setFocusedInput(focusedInput);
    },
    monthFormat: "DD/MM/YYYY",
    startDatePlaceholderText: "Data inicial",
    endDatePlaceholderText: "Data final"
  })));
};

DateRange.defaultProps = {
  startDate: null,
  endDate: null,
  focusedInput: null
};
var _default = DateRange;
exports.default = _default;